import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AgGridAngular } from '@ag-grid-community/angular';

@Injectable()
export class AgGridApiBusService {
    public readonly agGridComponent: ReplaySubject<AgGridAngular> = new ReplaySubject<AgGridAngular>();

    public initAgGridComponent(agGridApi: AgGridAngular): void {
        this.agGridComponent.next(agGridApi);
    }
}
